import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {ApiUrl} from "../shared/models/apiurl.models";
import {SystemApp} from "../constans/SystemConfigurations";
import {UsersService} from "../admin/users/users.service";

@Injectable({
    providedIn: 'root',
})
export class WebSocketService {
    private socket!: WebSocket;
    private messagesSubject = new Subject<any>();
    public messages$ = this.messagesSubject.asObservable();

    private reconnectInterval = 5000; // 5 seconds
    private roomName!: string;

    private typingTimeout!: any;
    private TYPING_DELAY = 3000; // 3 seconds

    constructor(private apiUrl: ApiUrl, private authService: UsersService) {}

    connect(room: string): void {
        const userDetails= this.authService.getLoginUserDetails();
        const email = userDetails.email
        const wsUrl = `${SystemApp.web_socket}chat/?token=${this.apiUrl.getJWTTokenKey()}`; // Adjust if needed
        console.log(wsUrl)
        this.socket = new WebSocket(wsUrl);

        this.socket.onopen = () => {
            console.log('WebSocket connected');
        };

        this.socket.onmessage = (event) => {
            console.log(event);
            try {
                const data = JSON.parse(event.data);
                this.messagesSubject.next(data);
            } catch (err) {
                console.error('Invalid message received:', event.data);
            }
        };

        this.socket.onclose = (event) => {
            console.warn('WebSocket closed. Reconnecting in 5s...', event.reason);
            setTimeout(() => this.connect(this.roomName), this.reconnectInterval);
        };

        this.socket.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.socket.close();
        };
    }

    send(data: any): void {
        if (this.socket?.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(data));
        } else {
            console.warn('WebSocket not connected. Cannot send:', data);
        }
    }

    disconnect(): void {
        if (this.socket) {
            this.socket.close();
        }
    }

    // Notify server that user is typing
    notifyTyping(): void {
        this.send({ type: 'typing' });

        // Clear any existing timeout and set a new one for "stop_typing"
        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            this.notifyStopTyping();
        }, this.TYPING_DELAY);
    }

    // Notify server that user stopped typing
    notifyStopTyping(): void {
        this.send({ type: 'stop_typing' });
    }
}
